import TruststoreUploadAndSignDocument from './TruststoreUploadAndSignDocument';

export default TruststoreUploadAndSignDocument;
